import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp, apiVerify } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {

	const dispatch = useDispatch()

	const navigate = useNavigate()

	const query = useQuery()

	const { token, signedIn, verified } = useSelector((state) => state.auth.session)

	const signIn = async (values) => {
		try {
			const resp = await apiSignIn(values)
			if (resp.data) {
				const { token } = resp.data
				if (resp.data.user) {
					dispatch(onSignInSuccess({ token, verified: resp.data.user.email_verified_at ? true : false }))
					dispatch(setUser(resp.data.user || {
						avatar: '',
						userName: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))

				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
				return {
					status: 'success',
					message: ''
				}
			}
		} catch (errors) {
			return {
				status: 'failed',
				message: errors?.response?.data?.message || errors.toString()
			}
		}
	}


	const verify = async (values) => {
		try {
			const resp = await apiVerify(values)
			if (resp.data) {
				if (resp.data.user && resp.data.verified) {
					dispatch(onSignInSuccess({ token, verified: resp.data.verified }))
					dispatch(setUser(resp.data.user || {
						avatar: '',
						userName: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))

				}
				// const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(appConfig.authenticatedEntryPath)
				return {
					status: 'success',
					message: ''
				}
			}
		} catch (errors) {
			return {
				status: 'failed',
				message: errors?.response?.data?.message || errors.toString()
			}
		}
	}

	const signUp = async (values) => {
		try {
			const resp = await apiSignUp(values)
			if (resp.data) {
				const { token } = resp.data
				if (resp.data.user) {
					dispatch(onSignInSuccess({ token, verified: resp.data.user.email_verified_at ? true : false }))
					dispatch(setUser(resp.data.user || {
						avatar: '',
						userName: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
				return {
					status: 'success',
					message: ''
				}
			}
		} catch (errors) {
			return {
				status: 'failed',
				message: errors?.response?.data?.message || errors.toString()
			}
		}
	}

	const handleSignOut = () => {
		dispatch(onSignOutSuccess())
		dispatch({ type: 'adminCasinoList/data/clearAll' });
		dispatch({ type: 'adminCodeList/data/clearAll' });
		dispatch({ type: 'adminCommissions/data/clearAll' });
		dispatch({ type: 'memberCommissions/data/clearAll' });
		dispatch({ type: 'userDashboard/data/clearAll' });
		dispatch({ type: 'adminInvestments/data/clearAll' });
		dispatch({ type: 'approvedInvestments/data/clearAll' });
		dispatch({ type: 'pendingInvestments/data/clearAll' });
		dispatch({ type: 'memberRewards/data/clearAll' });
		dispatch({ type: 'adminLocations/data/clearAll' });
		dispatch({ type: 'adminMemberList/data/clearAll' });
		dispatch({ type: 'adminWithdrawals/data/clearAll' });
		dispatch({ type: 'memberWithdrawals/data/clearAll' });
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

	const signOut = async () => {
		await apiSignOut()
		handleSignOut()
	}

	return {
		authenticated: token && signedIn,
		verified,
		signIn,
		signUp,
		signOut,
		verify
	}
}

export default useAuth